
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic02Off as ObiLogic02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-02-off.js';
 
 
 

 
 export const ObiLogic02Off = createComponent({
   react: React,
   tagName: 'obi-logic-02-off',
   elementClass: ObiLogic02OffElement,
   events: {
     
   }
  });
 
 